<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card card-form">
                    <div class="card-body">
                        <div class="row" v-if="!loading">
                            <div class="col-12 col-md-6">
                                <company-profile :companyData="companyData"></company-profile>
                            </div>
                            <div class="col-12 col-md-6">
                                <company-registration-certificate-add-edit-view :data="companyData.companyRegistrationCertificate"></company-registration-certificate-add-edit-view>
                                <company-license v-if="companyData.compLicense.id!=null" :data="companyData.compLicense"></company-license>
                                <company-insurance :data="companyData.compInsurance"></company-insurance>
                                <company-certificate :data="companyData.compCertificate"></company-certificate>
                                <WorkingPreciousMetalsStones :data="companyData.preciousMetalsStones"></WorkingPreciousMetalsStones>
                            </div>
                        </div>
                        <div class="row" v-else-if="loading">
                            <div class="col-12">
                                <loading></loading>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CompanyProfileEdit from '@/views/company/profile/CompanyProfileEdit'
    import CompanyLicenseEdit from '@/views/company/profile/CompanyLicenseEdit'
    import CompanyInsuranceEdit from '@/views/company/profile/CompanyInsuranceEdit'
    import CompanyCertificateEdit from '@/views/company/profile/CompanyCertificateEdit'
    import CompanyRegistrationCertificateAddEditView from '@/views/company/profile/CompanyRegistrationCertificateAddEditView'
    import WorkingPreciousMetalsStonesAddEdit from '@/views/company/profile/WorkingPreciousMetalsStonesAddEdit'
    import Loading from "@/views/Loading";
    export default {
        name: "CompanyView",
        components: {
            Loading,
            CompanyProfile: CompanyProfileEdit,
            CompanyLicense: CompanyLicenseEdit,
            CompanyInsurance: CompanyInsuranceEdit,
            CompanyCertificate: CompanyCertificateEdit,
            CompanyRegistrationCertificateAddEditView: CompanyRegistrationCertificateAddEditView,
            WorkingPreciousMetalsStones: WorkingPreciousMetalsStonesAddEdit
        },
        data() {
            return {
                loading: false,
                companyData: null
            }
        },
        methods: {
            init() {
                this.loading = true;
                this.$http.get('/company/view')
                    .then(res => {
                        this.companyData = res.data;
                        this.loading = false;
                    }, err => {
                        console.log(err);
                        this.loading = false;
                    })
            }
        },
        created() {
            this.init();
        }
    }
</script>

<style scoped>

</style>